import React from "react";
import { Typography, Stack, useTheme, useMediaQuery } from "@mui/material";

const ProductTitle = ({ subcategory, displayName, flavor }) => {
  const hideDisplayName = [
    "cupcake",
    "cookie",
    "macaron",
    "cheesecakeSlice",
  ].includes(subcategory);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!displayName && !flavor) return null;

  return (
    <Stack
      direction={isMobile ? "column" : "row"}
      spacing={isMobile ? 0 : 1}
      justifyContent="center"
      alignItems="center"
      sx={{ mb: 1, textAlign: "center" }}>
      {!hideDisplayName && (
        <Typography variant="subtitle1" fontWeight="bold">
          {displayName}
        </Typography>
      )}
      {flavor && (
        <Typography
          variant={hideDisplayName ? "h6" : "subtitle1"}
          color="text.secondary">
          {hideDisplayName ? flavor : `– ${flavor}`}
        </Typography>
      )}
    </Stack>
  );
};

export default ProductTitle;
